/**
 * Single source of truth for site-wide business facts.
 *
 * Everything here is real data pulled from the HappySpace business record
 * (businessId 6a7f449b9a3f04c48593928c). Fields the business has NOT filled in
 * yet keep the platform's `[Edit: …]` placeholder convention so the owner can
 * complete them in the editor — do not invent values for these.
 */

export const BUSINESS_ID = '6a7f449b9a3f04c48593928c';

export const SITE = {
  name: 'Yalla Eat',
  tagline: 'Halal Fresh Food',
  strapline: 'Delicious. Fresh. Halal.',
  about: 'We serve 100% halal food to our customers.',
  /** From businesses.locations[0] */
  address: '2380 E Park Blvd Ste 404, Plano, TX 75074',
  addressLines: ['2380 E Park Blvd, Ste 404', 'Plano, TX 75074'],
  phone: '(214) 440-2049',
  /** tel: href form, E.164 so mobile dialers handle it correctly. */
  phoneHref: 'tel:+12144402049',
  email: 'yallaeatdfw@gmail.com',
  emailHref: 'mailto:yallaeatdfw@gmail.com',
  hours: 'Mon - Sat, 11:00 AM - 10:00 PM',
  hoursLines: ['Monday - Saturday', '11:00 AM - 10:00 PM'],
  /** businesses.defaultPickupMinutes */
  pickupMinutes: 20,
  /** businesses.taxRate */
  taxRate: 0.08,
  /**
   * Social profiles. Only entries with a URL render as links, so an unset
   * network is omitted rather than shipping a dead "#" link.
   */
  social: {
    instagram: 'https://www.instagram.com/yallaeathalal/',
    facebook: 'https://www.facebook.com/profile.php?id=61592194765349',
    tiktok: 'https://www.tiktok.com/@yalla.eat4',
  },
  /** locations[0].fulfillment — pickup only for now. */
  fulfillment: { pickup: true, delivery: false },
} as const;

export const MAPS_QUERY = encodeURIComponent(SITE.address);

/** Order the menu categories the way a customer reads a board. */
export const CATEGORY_ORDER = [
  'Shawarma',
  'Combo Shawarma',
  'NYC Gyro',
  'Platters',
  'Burgers',
  'Wings',
  'Family Combo',
  'Side/Kids Menu',
  'Cool Drinks',
];

export function sortCategories<T extends { name: string }>(cats: T[]): T[] {
  return [...cats].sort((a, b) => {
    const ia = CATEGORY_ORDER.indexOf(a.name);
    const ib = CATEGORY_ORDER.indexOf(b.name);
    return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
  });
}

export function stripHtml(s?: string) {
  return (s || '').replace(/<[^>]+>/g, '').trim();
}

export function money(n: number) {
  return `$${n.toFixed(2)}`;
}
